const state = {
  selectedPersonal: '',
};

const mutations = {
  selectPersonal(state, legajo) {
    state.selectedPersonal = legajo;
  },
};

const getters = {
  getSelectedPersonal: (state) => state.selectedPersonal,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};


